<template>
  <div>
    <div v-if="profile" class="user">
      <div class="avatar"><img :src="profile.photo" /></div>
      <span class="name">{{ profile.mail }}</span>
    </div>
    <div v-if="!profile" class="user">
      <div class="avatar demo"><font-awesome-icon icon="user" /></div>
      <span class="name">piggybank demo</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      profile: undefined,
    };
  },
  mounted() {
    this.profile = this.$gAuth.getProfile();

    this.$root.$on("logged", () => {
      this.profile = this.$gAuth.getProfile();
      this.$forceUpdate();
    });

    this.$root.$on("logged-out", () => {
      this.profile = this.$gAuth.getProfile();
      this.$forceUpdate();
    });
  },
};
</script>

<style lang="scss" scoped>
.user {
  display: flex;
  flex-direction: column;
  align-items: center;

  .avatar {
    position: relative;
    width: 96px;
    height: 96px;
    border-radius: 50%;
    overflow: hidden;

    &.demo {
      line-height: 96px;
      font-size: 80px;
      background: red;

      & > * {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  .name {
    font-size: 20px;
    font-weight: 100;
    margin-top: 10px;
  }
}
</style>